var _style, _path, _path2, _g, _g2, _g3, _path3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#FFDA44;}\n\t.st2{fill:#0052B4;}\n\t.st3{fill:#D80027;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,0C256,0,256,0,256,0L256,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M512,256c0,141.4-114.6,256-256,256S0,397.4,0,256C0,256.1,256,0,256,0C397.4,0,512,114.6,512,256z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,122.4v86.3l-89-86.3H256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.6,256h75.2l-75.2-100.2l-11.1,77.9L133.6,256z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.3,256h0.7c0-0.2,0-0.5,0-0.7C255.8,255.5,255.5,255.8,255.3,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,133.6c0-45,0-74.6,0-133.6h0C114.6,0,0,114.6,0,256h133.6v-75.2l75.2,75.2h46.5c0.2-0.2,0.5-0.5,0.7-0.7 c0-17.2,0-32.6,0-46.5l-75.2-75.2H256z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256,224.5l-91-91h-31.5v0L256,256h0C256,256,256,234.3,256,224.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M129.5,33.4c-9.9,5.6-19.3,11.9-28.3,18.7h10.5L83.9,72.3l10.6,32.6L66.8,84.8l-3,2.1 c-11.5,13.1-21.7,27.4-30.4,42.6V256h66.8V100.2v0H256c0-21.1,0-41.1,0-66.8H129.5z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.4,46.2c-2.8,1.9-5.5,3.9-8.2,6L83.9,72.3L66.8,84.8l-3,2.2c-6.3,7.1-12.2,14.6-17.7,22.4 c6.2,3,13.2,4.7,20.6,4.7c26.1,0,47.3-21.2,47.3-47.3C114.1,59.4,112.4,52.4,109.4,46.2z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.8,86.9l3-2.2l27.8,20.2L83.9,72.3l27.8-20.2h-10.5C87.6,62.4,75.1,74.1,63.8,86.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.9,44.5l5.5,17h17.9L185.9,72l5.5,17l-14.5-10.5L162.5,89l5.5-17l-14.5-10.5h17.9L176.9,44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.8,155.8l5.5,17h17.9l-14.5,10.5l5.5,17l-14.5-10.5l-14.5,10.5l5.5-17l-14.5-10.5h17.9L66.8,155.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNu);
export default __webpack_public_path__ + "static/media/nu.297c63b3b9f653bde4ad94b3c7157a9d.svg";
export { ForwardRef as ReactComponent };